<div class="auth-wrapper auth-v1 px-2">
  <div class="auth-inner py-2">
    <div class="card mb-0">
      <div class="card-body">
        <a href="javascript:void(0);" class="brand-logo">
          <div class="brand-logo">
            <img src="../../../../../assets/images/pages/logo_white.png" alt="brand-logo" />
          </div>
        </a>

        <h4 class="card-title mb-1">Reset Password 🔒</h4>
        <p class="card-text mb-2">Your new password must be different from previously used passwords</p>

        <form class="auth-reset-password-form mt-2" [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="reset-password-new">New Password</label>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="passwordTextType ? 'text' : 'password'"
                class="form-control"
                formControlName="newPassword"
                placeholder="············"
                [ngClass]="{ 'is-invalid': submitted && f.newPassword.errors }"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer" (click)="togglePasswordTextType()">
                  <i [class]="passwordTextType ? 'feather icon-eye' : 'feather icon-eye-off'"></i>
                </span>
              </div>
            </div>
            <div *ngIf="submitted && f.newPassword.errors" class="invalid-feedback">
              <div *ngIf="f.newPassword.errors.required">Password is required</div>
              <div *ngIf="f.newPassword.errors.minlength">
                Password must be at least 6 characters
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="reset-password-confirm">Confirm Password</label>
            <div class="input-group input-group-merge form-password-toggle">
              <input
                [type]="confPasswordTextType ? 'text' : 'password'"
                class="form-control"
                formControlName="confirmPassword"
                placeholder="············"
                [ngClass]="{ 'is-invalid': submitted && (f.confirmPassword.errors || resetPasswordForm.errors?.mismatch) }"
              />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer" (click)="toggleConfPasswordTextType()">
                  <i [class]="confPasswordTextType ? 'feather icon-eye' : 'feather icon-eye-off'"></i>
                </span>
              </div>
            </div>
            <div *ngIf="submitted && (f.confirmPassword.errors || resetPasswordForm.errors?.mismatch)" class="invalid-feedback">
              <div *ngIf="f.confirmPassword.errors?.required">Confirm Password is required</div>
              <div *ngIf="resetPasswordForm.errors?.mismatch">Passwords must match</div>
            </div>
          </div>

          <button
            type="submit"
            class="btn btn-primary btn-block mt-2"
            [disabled]="(loaderService._observer | async)?.isLoading || resetPasswordForm.invalid"
            rippleEffect
          >
            <app-loader></app-loader>
            <span>{{
              (loaderService._observer | async)?.isLoading
                ? "Processing"
                : "Set New Password"
            }}</span>
          </button>
        </form>

        <div class="text-center mt-2">
          <a routerLink="/auth/login" class="d-flex align-items-center justify-content-center">
            <i data-feather="chevron-left"></i>
            <span>Back to login</span>
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
